import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

import type { AlertVariants } from './Alert'

type AlertProps = {
  kind: AlertVariants
  fullWidth: boolean
}

const kindVariants = {
  error: css`
    background-color: ${theme.colors.alert.danger[20]};
    border: 1px solid ${theme.colors.alert.danger.dark};
  `,
  info: css`
    background-color: ${theme.colors.alert.info[20]};
    border: 1px solid ${theme.colors.alert.info.dark};
  `,
  success: css`
    background-color: ${theme.colors.alert.success[20]};
    border: 1px solid ${theme.colors.alert.success.dark};
  `,
  warning: css`
    background-color: ${theme.colors.alert.warning[20]};
    border: 1px solid ${theme.colors.alert.warning.dark};
  `,
}

export const Container = styled.div<AlertProps>`
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.xm};
  align-items: center;

  ${({ kind, fullWidth }) => css`
    ${kindVariants[kind]}
    width: ${fullWidth ? '100%' : 'fit-content'};
  `}
`

export const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  span,
  strong {
    font-size: ${theme.typography.sizes.xs};
    color: ${theme.colors.neutral.black};
  }

  strong {
    font-family: ${theme.typography.family.bold};
  }
`

export const TitleRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`
